import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function Shipping() {
  const navigate = useNavigate();

  const tmStyle = {
    fontSize: '0.5em',
    verticalAlign: 'super'
  };

  return (
    <div className="legal-page">
      <h1>Shipping</h1>

      <section className="terms-usage">
        <p>
          We currently ship only within the United States.<br /><br />
          All orders are carefully packed in custom-printed boxes with decorative wrapping and protective shredded paper to ensure a premium unboxing experience.<br /><br />
          A flat-rate shipping fee of <strong>$8.95</strong> applies to all orders, regardless of size or quantity. This fee helps cover not only the cost of shipping, but also the premium packaging materials included with every order.<br /><br />
          Orders are typically processed within 2–3 business days. Shipping usually takes 3–7 business days, depending on your location.
        </p>
      </section>

      <section className="terms-contact">
        <h2>Contact</h2>
        <p>
          If you experience any issues with your order, please reach out to us at <a href="mailto:support@neucraft.shop">support@neucraft.shop</a>.
        </p>
      </section>

      <div className="productpage-actions productpage-actions-row" style={{ justifyContent: 'flex-start', marginTop: '80px' }}>
        <button className="card-btn productpage-btn-small" onClick={() => navigate('/')} type="button" style={{ cursor: 'pointer' }}>
          &larr; Home
        </button>
      </div>
    </div>
  );
}